module.exports = __webpack_public_path__ + "img/banner_1.ffc5eff0.jpg";